//
//
//
//
//
//

export default {
  name: 'divider'
}



// WEBPACK FOOTER //
// ./~/vux/src/components/divider/index.vue